export default __webpack_public_path__ + "static/media/p-logo.05f3bfd9.svg";